// extracted by mini-css-extract-plugin
export default {"containerSearchBar":"SearchBar_containerSearchBar__W81Kz","inputSearch":"SearchBar_inputSearch__ryI-y"};